import { PurchaseDetail, PurchaseFormValues } from '../../types/purchases/BasePurchase';

export function mapDebitNotePurchaseToFormValues(purchase: PurchaseDetail): PurchaseFormValues {
  const debitNote = purchase.debitNoteDetails;

  const subtotal = debitNote?.subtotal ?? 0;
  const ivaTotal = debitNote?.ivaTotal ?? 0;
  const totalToAdd = debitNote?.totalToAdd ?? null;

  return {
    id: purchase.id,
    documentType: purchase.documentType,
    documentNumber: purchase.documentNumber,
    purchaseDate: purchase.purchaseDate,
    supplier: purchase.supplier,
    comments: purchase.comments || '',
    cancellationReason: purchase.cancellationReason || '',
    products: debitNote?.products || debitNote?.details || [], // ✅ híbrido
    paymentCondition: null,

    creditDueDate: '',
    creditDays: 0,
    totalQuantity: null,
    netAmount: null,
    freight: null,
    insurance: null,
    fauca: null,
    otherCosts: null,
    exportIva: null,
    totalCost: null,

    taxableSubtotal: subtotal,
    perceivedIVA: ivaTotal,
    totalToRefund: totalToAdd,
    withheldIVA: 0,
  };
}
